import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepsComponent } from './steps.component';



@NgModule({
  declarations: [
    StepsComponent
  ],
  imports: [
    CommonModule
  ], 
  exports: [
    StepsComponent
  ]
})
export class StepsModule { }
